
$(document).ready(function () {

// handle share facebook / twitter
$('.share-popup').on('click', (e) => {
        const link = $(e.currentTarget);
        // pop-up window size
        const config = {
            width: 626,
            height: 300
        };

        // popup position
        const px = Math.floor(((screen.availWidth || 1024) - config.width) / 2),
            py = Math.floor(((screen.availHeight || 700) - config.height) / 2);

        // open popup
        const popup = window.open(link.data('url'), "social",
            "width="+config.width+",height="+config.height+
            ",left="+px+",top="+py+
            ",location=0,menubar=0,toolbar=0,status=0,scrollbars=1,resizable=1");

        if (popup) {
            popup.focus();
            if (e.preventDefault) e.preventDefault();
            e.returnValue = false;
        }
});

});


// WEBPACK FOOTER //
// ./app/components/share/social/social.js